// noise-component.js

import Alpine from 'alpinejs'
import { createNoiseCanvas } from './noise-canvas.js'

const COLOR_MAP = {
  white:        [1.0,  0.95, 0.90],
  black:        [0.17, 0.08, 0.11],
  green:        [0.42, 0.76, 0.30],
  pink:         [1.0,  0.42, 0.54],
  purple:       [0.69, 0.59, 1.0 ],
  blueDark:     [0.13, 0.34, 0.97],
  blueLight:    [0.16, 0.70, 1.0 ],
  yellow:       [1.0,  0.69, 0.20],
}

function resolveColor(key) {
  const color = COLOR_MAP[key]
  if (!color) {
    console.warn(`noise-canvas: unknown color key "${key}", falling back to white`)
    return COLOR_MAP.white
  }
  return color
}

function parseConfig(el) {
  return {
    color1:   resolveColor(el.dataset.color1   ?? 'white'),
    color2:   resolveColor(el.dataset.color2   ?? 'white'),
    mode:     el.dataset.mode                  ?? 'mono',
    density:  el.dataset.density  ? parseFloat(el.dataset.density)  : 0.96,
    opacity:  el.dataset.opacity  ? parseFloat(el.dataset.opacity)  : 0.6,
    cellSize: el.dataset.cellSize ? parseFloat(el.dataset.cellSize) : 0.75,
    blend:    el.dataset.blend                 ?? 'screen',
    alphaFloor: el.dataset.alphaFloor ? parseFloat(el.dataset.alphaFloor) : 0.0,
  }
}

Alpine.data('noiseCanvas', () => ({
  instance: null,

  init() {
    this.instance = createNoiseCanvas(this.$el, parseConfig(this.$el))
  },

  destroy() {
    this.instance?.destroy()
  },
}));